import { NgModule } from '@angular/core';
import { FeatureDirective } from './feature.directive';

@NgModule({
  exports: [FeatureDirective],
  declarations: [FeatureDirective],
})
export class FeatureModule {}
